// extracted by mini-css-extract-plugin
export var divider = "_r8-0";
export var systemMessage = "_r8-1";